<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div>
          <div class="content">
            <div class="col-sm-3 col-xs-3">
              <div v-for="category in filteredTopCategories" :class="{'active': category.id === selectedCategory}" class="btn btn-danger category-btn" style="display: inline-flex" @click="showBrands(category.id)">
                <div style="width: 30px">
                  <img v-if="category.imageLocation" height="20" style="margin-right: 5px;" :src="BACKEND_BASE_URL + '/images/' + category.imageLocation">
                </div>
                {{ getLocale() == 'nl' ? category.dutchTranslation : category.frenchTranslation}}
              </div>
              <div v-if="$can('btonly')" class="btn btn-danger add-category-btn" @click="showAddCategoryModal()"><i
                class="glyphicon glyphicon-plus"></i></div>
            </div>
            <div class="col-sm-9 col-xs-9">
              <div class="row">
                <div class="col-sm-12">
                  <div v-if="selectedCategory !== null && $can('btonly')" class="pull-right btn btn-success" @click="showAddBrandModal()">Merk toevoegen</div>
                </div>
              </div>
              <div v-for="brand in brandsForCategory" class="col-sm-4 col-xs-6 brand-image-container">
                <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-trash" @click="deleteBrand(brand)"></i>
                <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-edit" @click="editBrand(brand)"></i>
                <a v-if="brand.url" :href="brand.url" target="_blank">
                  <img v-if="brand.imageLocation" class="brand-image"
                       :src="BACKEND_BASE_URL + '/images/' + brand.imageLocation">
                </a>
                <img v-if="brand.imageLocation && !brand.url" class="brand-image"
                     :src="BACKEND_BASE_URL + '/images/' + brand.imageLocation">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bt-footer/>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import BtHeader from './BTHeader.vue'
  import BtFooter from './BTFooter.vue'
  import * as types from '../store/mutation-types'

  export default {
    name: 'Brands',
    components: {
      BtHeader,
      BtFooter
    },
    created () {
      document.title = 'Brabant-Tools | Merken'
      this.$store.dispatch('getTopCategories').then(() => {
        if (this.topCategories.length > 0) {
          this.selectedCategory = this.topCategories[0].id
          this.$store.dispatch('getBrandsForCategory', this.topCategories[0].id)
        }
      })
    },
    data () {
      return {
        BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
        images: [],
        selectedCategory: null,
        showModal: false,
        file: null
      }
    },
    methods: {
      getLocale () {
        return this.$i18n.locale
      },
      showBrands (categoryId) {
        this.selectedCategory = categoryId
        this.$store.dispatch('getBrandsForCategory', categoryId)
      },
      deleteBrand (brand) {
        this.$swal({
          title: 'Let op!',
          text: 'Je staat op het punt om een merk te verwijderen. Deze actie kan niet ongedaan worden!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Verwijderen',
          cancelButtonText: 'Annuleren'
        }).then((result) => {
          if (result) {
            this.$store.commit(types.REMOVE_BRAND_FROM_BRANDS, brand.id)
            this.$store.dispatch('deleteBrand', brand.id)
          }
        })
      },
      editBrand (brand) {
        this.$modal.show('add-brand-modal', {brand: brand})
      },
      showAddCategoryModal () {
        this.$modal.show('add-category-modal')
      },
      showAddBrandModal () {
        this.$modal.show('add-brand-modal', {categoryId: this.selectedCategory})
      }
    },
    computed: {
      ...mapGetters({
        topCategories: 'topCategories',
        brandsForCategory: 'brandsForCategory'
      }),
      filteredTopCategories () {
        return this.topCategories.sort((a, b) => a.dutchTranslation.localeCompare(b.dutchTranslation))
      }
    }
  }
</script>

<style scoped>
  .glyphicon {
    cursor: pointer;
  }

  .brand-image-container .glyphicon{
    display:none;
  }

  .brand-image-container:hover .glyphicon {
    display:inline-block;
  }

  .category-btn {
    margin-bottom: 2px;
    width: 85%;
    text-align: left;
    white-space: normal;
  }

  .add-category-btn {
    width: 85%;
    text-align: center;
  }

  .brand-image-container {
    height: 100px;
    width: 140px;
    text-align: center;
    margin: 5px 10px;
  }

  .brand-image {
    max-width: 140px;
  }

  .helper {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
</style>
